<template>
  <div class="about-us" oncontextmenu="return false" onselectstart="return false">
    <!--顶部-->
    <header-nav :current="current"></header-nav>
    <div class="content" id="pdfDom" ref="content">
      <div class="table" :class="{'pdfheight': isPrint}">
        <h1 class="title">
          <p>【汉语儿童理解与表达词汇测验】</p>
          <br/>
          <p>三至六岁儿童个人报告</p>
        </h1>
        <div class="author">
          <p>
            <span>
              Receptive and Expressive Vocabulary Test （REVT）
            </span>
          </p>
          <p>黄瑞珍、简欣瑜、朱丽璇、卢璐编制</p>
        </div>

        <div class="head-title">
          <p class="main-title tx-l">基本资料</p>
          <p class="sn" style="color: #0c2047">个案编号：{{baseInfo.sn}}</p>
        </div>
        <table border="1" cellspacing="1" cellpadding="0">
          <tr>
            <th width="140px">姓名</th>
            <td>
              <div class="input">
                <span>{{baseInfo.name}}</span>
              </div>
            </td>
            <th width="140px">评估日期</th>
            <td>
              <div class="input">
                <span>{{baseInfo.exam_date}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">性别</th>
            <td>
              <div class="input">
                <span>{{baseInfo.sex}}</span>
              </div>
            </td>
            <th width="140px">出生日期</th>
            <td>
              <div class="input">
                <span>{{baseInfo.birthday}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">地区</th>
            <td>
              <div class="input">
                <span>{{baseInfo.province}}</span>
              </div>
            </td>
            <th width="140px">实足年龄</th>
            <td>
              <div class="input">
                <span>{{baseInfo.age}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">就读学校</th>
            <td>
              <div class="input">
                <span>{{baseInfo.school}}</span>
              </div>
            </td>
            <th width="140px">施测人员</th>
            <td>
              <div class="input">
                <span>{{baseInfo.operator}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">转介者</th>
            <td>
              <div class="input">
                <span>{{baseInfo.referral_user}}</span>
              </div>
            </td>
            <th width="140px">转介理由</th>
            <td>
              <div class="input">
                <span>{{baseInfo.referral_reason}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">施测地点</th>
            <td>
              <div class="input">
                <span>{{baseInfo.operator_area}}</span>
              </div>
            </td>
            <th width="140px"></th>
            <td>
              <div class="input">
                <span>{{baseInfo.create_time}}</span>
              </div>
            </td>
          </tr>
        </table>
        <br>
        <br>
        <p class="main-title tx-l">量表介绍</p>
        <div class="info-description">
          <p class="tips tx-idt2">
            《汉语儿童理解与表达词汇测验》（REVT）由黄瑞珍、简欣瑜、朱丽璇、卢璐参考国内外文献，从认知发展的角度探讨儿童词汇学习的特质与进程，同时参考汉语词汇特性编制本测验，并本着严谨的态度保证其验证结果的信效度。本测验分成理解与表达两个量表，以下又细分为四个分测验。测验目的是帮助使用者理解学龄前儿童的词汇发展，用来鉴定词汇发展迟缓儿童，以利于早期介入、早期疗育。
          </p>
          <p class="tips tx-idt2">
            理解量表：理解（receptive；简称R）是指对于言辞意义的了解或解码，代表听话者了解他人说话内容的能力。理解量表主要以施测者依据题本给予指示，请儿童依据题目要求进行词汇选择。量表内容依据3-7岁儿童认知发展细分为「命名」、「归类」、「定义」以及「推理」四个分测验。
          </p>
          <p class="tips tx-idt2">
            表达量表：表达（expressive；简称E）则是指使用言辞概念说出的过程或编码，表示个人产生有意义言语的能力。表达量表施测方式为施测者依据题目提问，儿童以口述的方式表达自己对词汇的概念。测验内容依据3-7岁儿童认知发展细分为「命名」、「归类」、「定义」以及「推理」四个分测验。
          </p>
        </div>
      </div>
      <br>
      <br>
      <!-- 分测验分数结果 -->
      <div class="table" :class="{'pdfheight': isPrint}">
        <p class="main-title tx-l">分测验分数结果</p>
        <div class="charts" id="charts2"></div>
        <!-- 表格列出所有分数 -->
        <table border="1" style="width: auto !important;">
          <tr>
            <th class="score-td-title">
              <!--              <div class="out">-->
              <!--                <b class="table-cate">分数</b>-->
              <!--                <em>类别</em>-->
              <!--              </div>-->
            </th>
            <th style="width: 189px">命名</th>
            <th style="width: 189px">归类</th>
            <th style="width: 188px">定义</th>
            <th style="width: 190px">推理</th>
          </tr>
          <template>
            <tr v-for="(score,index) in cateEchart.table" :key="index">
              <td class="score-td-title">
                <template v-if="index == 0">
                  原始分数
                </template>
                <template v-if="index == 1">
                  标准分数
                </template>
                <template v-if="index == 2">
                  百分等级
                </template>
              </td>
              <template v-if="index === 0">
                <td class="score-td">{{ score[0] }}<span class="cate-symbol">/</span><span class="cate-full">48</span></td>
                <td class="score-td">{{ score[1] }}<span class="cate-symbol">/</span><span class="cate-full">95</span></td>
                <td class="score-td">{{ score[2] }}<span class="cate-symbol">/</span><span class="cate-full">59</span></td>
                <td class="score-td">{{ score[3] }}<span class="cate-symbol">/</span><span class="cate-full">30</span></td>
              </template>
              <template v-else>
                <td class="score-td">{{ score[0] }}</td>
                <td class="score-td">{{ score[1] }}</td>
                <td class="score-td">{{ score[2] }}</td>
                <td class="score-td">{{ score[3] }}</td>
              </template>
            </tr>
          </template>
        </table>
        <p class="main-title tx-l">量表分数结果</p>
        <div class="charts" id="charts3"></div>
        <!-- 表格列出所有分数 -->
        <table border="1" style="width: auto !important;">
          <tr>
            <th class="score-td-title">
            </th>
            <th style="width: 256px !important;">理解量表</th>
            <th style="width: 256px !important;">表达量表</th>
            <th style="width: 256px !important;">全测验</th>
          </tr>
          <template>
            <tr v-for="(score,index) in allEchart.table" :key="index">
              <td class="score-td-title">
                <template v-if="index === 0">
                  原始分数
                </template>
                <template v-if="index === 1">
                  标准分数
                </template>
                <template v-if="index === 2">
                  百分等级
                </template>
              </td>
              <td class="score-td">{{ score[0] }}</td>
              <td class="score-td">{{ score[1] }}</td>
              <td class="score-td">{{ score[2] }}</td>
            </tr>
          </template>
        </table>
      </div>
      <br>
      <br>
      <div class="table" :class="{'pdfheight': isPrint}">
        <p class="main-title tx-l" v-if="tip">分数说明</p>
        <table border="1">
          <tr>
            <td style="width: 220px;">分测验标准分数</td>
            <td>
              分测验标准分数是以10为平均数、3为标准差，标准分数介于1-19之间，以此分成七个等级：能力不足（1-3）、低下（4-5）、中下（6-7）、中等普通（8-12）、中上（13-14）、优秀（15-16）及非常优秀（17-19）。
            </td>
          </tr>
          <tr>
            <td style="width: 220px;">量表与全测验标准分数</td>
            <td>
              量表与全测验标准分数是以100为平均数、15为标准差转换而成。本量表将标准分数分成七个等级：能力不足（≦69）、低下（70-79）、中下（80-89）、中等普通（90-109）、中上（110-119）、优秀（120-129）及非常优秀（≧130）。
            </td>
          </tr>
          <tr>
            <td style="width: 220px;">百分等级</td>
            <td>
              百分等级是依据常模数据换算而得，代表受试者在100个人当中所排列的位置，来检视儿童语言发展。在本量表百分等级越高，代表表现越佳，以此了解儿童在该年龄组的得分情形。            </td>
          </tr>
        </table>
      </div>
      <br>
      <br>
      <div class="table" :class="{'pdfheight': isPrint}">
        <p class="main-title tx-l" v-if="tip">个人分数说明、介入计划与建议</p>
      </div>
      <div class="table" :class="{'pdfheight': isPrint}">
        <p class="subheading">分测验</p>
        <div class="result-remark">
          婴幼儿自出生开始，藉由与照顾者间紧密的互动，逐渐学会各种人事物的名称，即是词汇学习的开始。当儿童具备200至300个词汇命名能力时，即进入归类能力。接着约为四岁时发展词汇定义能力，往后五至六岁则发展词汇推理能力。因此本测验设计四个分测验，以完整评估儿童词汇发展所应具备的各式能力。
        </div>
        <table border="1">
          <template>
            <tr v-for="(result,index) in cateResult" :key="index">
              <td style="width: 75px;">{{ result.title }}</td>
              <td v-html="result.res"></td>
            </tr>
          </template>
        </table>
      </div>
      <br>
      <br>
      <div class="table" :class="{'pdfheight': isPrint}">
        <p class="subheading">量表与全测验</p>
        <table border="1">
          <template>
            <tr v-for="(result,index) in allResult" :key="index">
              <td style="width: 75px;">{{ result.title }}</td>
              <td>
                {{result.res}}
              </td>
            </tr>
          </template>
        </table>
      </div>
      <br>
      <br>
      <div class="table" :class="{'pdfheight': isPrint}">
        <p class="main-title tx-l">施测者观察记录<span style="font-size: 12px !important;">（双击下方空白区域可编辑观察记录）</span></p>
        <table border="1">
          <tr>
            <td style="height: 250px;">
              <div v-if="!isEditing" @dblclick="startEdit" style="padding: 10px; min-height: 230px; white-space: pre-wrap;">{{ remark }}</div>
              <div v-else>
                <textarea v-model="editingRemark" style="width: 100%; height: 170px; padding: 10px; border: 1px solid #dcdfe6; border-radius: 3px; resize: vertical; font-size: 16px; font-family: inherit; box-sizing: border-box;"></textarea>
                <div style="text-align: right; padding: 8px 10px 0;">
                  <button type="button" @click="saveRemark" style="padding: 5px 18px; background: #0c2047; color: #fff; border: none; border-radius: 3px; cursor: pointer; font-size: 14px;">保存</button>
                  <button type="button" @click="cancelEdit" style="padding: 5px 18px; margin-left: 6px; background: #fff; color: #333; border: 1px solid #ccc; border-radius: 3px; cursor: pointer; font-size: 14px;">取消</button>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="table" :class="{'pdfheight': isPrint}">
        <p class="main-title tx-l">备注</p>
        <div style="padding: 10px 0 25px 28px;font-size: 22px;font-weight: bold;color: #333">如果您对本测验结果或解释有任何疑问，或是想进一步了解的地方请与施测人员联系沟通。</div>
      </div>

    </div>
<!--    <button class="print" v-on:click="printPdf">打印</button>-->
    <button class="print" v-on:click="download">下载</button>
    <!--底部-->
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import HeaderNav from "@/components/HeaderNav";
import FooterNav from "@/components/FooterNav";
import echarts from "echarts";
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export default {
  name: "aboutus",
  data() {
    return {
      current: "",
      baseInfo:{},
      isPrint: false,
      allEchart:{},
      cateEchart:{},
      cateResult:{},
      allResult:{},
      tip:true,
      remark: '',
      editingRemark: '',
      isEditing: false
    };
  },
  components: {
    HeaderNav,
    FooterNav
  },
  methods: {
    getData() {
      let params = {
        exam_id: this.$route.query.eid
      };
      this.$post("report/getReport", params)
          .then(res => {
            if (res.code === 1) {
              this.baseInfo = res.data.base_info
              this.remark = res.data.remark || '';
              this.allEchart = res.data.all
              this.cateEchart = res.data.cate
              this.cateResult = res.data.result.cate
              this.allResult = res.data.result.other
              this.$nextTick(() => {
                this.drawLine(this.cateEchart.echart); //页面上没有charts2元素，会报错
                this.drawLine2(this.allEchart.echart);
                if (this.$route.query.print) {
                  setTimeout(async () => {
                    await this.download();
                  },1000)
                }
              });

            } else {
              this.$layer.msg(res.msg);
            }
          })
          .catch(response => {
            this.$layer.msg("网络异常，请稍后重试！");
          });
    },
    drawLine2(data) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("charts3"));
      // 绘制图表
      // 绘制图表
      let seriesLabel = {
        normal: {
          show: true,
          color: "black",
          fontSize:18,
          position: "top" //在上方显示
        }
      };
      myChart.setOption({
        title: {
          textAlign: "left",
          x: "center",
          y: "top"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          left: "88px",
          right: "8%",
          bottom: "6%",
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [
              "理解量表",
              "表达量表",
              "全测验"
            ],
            axisLabel: {
              fontSize:18
            }
          }
        ],
        yAxis: {
          name: "标准分数",
          nameTextStyle: {
            fontSize: 18,  // 设置字体大小（单位px）,
          },
          type: "value",
          min:60,
          max:150,
          interval:10,
          splitLine: {
            lineStyle: {
              color: '#000', // 默认刻度线（灰色虚线）
              width: 1,
              type: 'dashed'
            }
          },
          axisLabel: {
            fontSize:18,
            formatter: function (value) {
              if (value === 100) {
                return '{a|' + value + '}'; // 使用富文本标记
              }
              return value;
            },
            rich: {
              a: {
                fontWeight: 'bold',
                color: '#3c7088',
                fontSize: 18
              }
            }
          }

        },
        series: [
          {
            name:'标准分数',
            type: "bar",
            barWidth:'18%',
            label: seriesLabel,
            data: data,
            itemStyle:{
              color:'#156082'
            },
            markLine: {
              silent: true,
              symbol: 'none',
              lineStyle: {
                width: 2,
                type: 'solid'
              },
              data: [{ yAxis: 100 }],
              z: 0,  // 分割线层级调低（在柱状图下方）
              label: { show: false }
            },
            z:5,
            markArea: {
              z: -1,
              silent: true,
              data: [
                [
                  {yAxis: 60,itemStyle: {color: 'rgba(57,73,171,0.8)'}},
                  {yAxis: 70}
                ],
                [
                  {yAxis: 70,itemStyle: {color: 'rgba(92,107,192,0.8)'}},
                  {yAxis: 80}
                ],
                [
                  {yAxis: 80,itemStyle: {color: 'rgba(121,134,203,0.8)'}},
                  {yAxis: 90}
                ]
              ]
            }
          }
        ]
      });
    },
    drawLine(data) {
      // 基于准备好的dom，初始化echarts实例
      let dom = document.getElementById("charts2")
      let myChart = echarts.init(dom);
      // 绘制图表
      let seriesLabel = {
        normal: {
          show: true,
          color: "black",
          fontSize:18,
          position: "top" //在上方显示
        }
      };
      myChart.setOption({
        title: {
          text: "",
          textAlign: "left",
          x: "center",
          y: "top"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: ["听懂", "说出"],
          orient: "horizontal",
          x: "right",
          y: "top"
        },
        grid: {
          left: "99px",
          right: "6%",
          bottom: "6%",
          containLabel: true
        },
        xAxis: [
          {
            name: "",
            type: 'category',
            data: [
              "命名",
              "归类",
              "定义",
              "推理"
            ],
            axisLabel: {
              fontSize:18
            }
          }
        ],
        yAxis: {
          name: "标准分数",
          nameTextStyle: {
            fontSize: 18,  // 设置字体大小（单位px）,
          },
          type: "value",
          data: [0,2,4,6,8,10,12,14,16,18,20],
          min:0,
          max:20,
          interval:2,
          splitLine: {
            lineStyle: {
              color: '#000', // 默认刻度线（灰色虚线）
              width: 1,
              type: 'dashed'
            }
          },
          axisLabel: {
            fontSize:18,
            formatter: function (value) {
              if (value === 10) {
                return '{a|' + value + '}'; // 使用富文本标记
              }
              return value;
            },
            rich: {
              a: {
                fontWeight: 'bold',
                color: '#3c7088',
                fontSize: 18
              }
            }
          }
        },
        series: [
          {
            name: '标准分数',
            type: 'bar',
            barWidth:'20%',
            label: seriesLabel,
            data: data,
            z:5,
            markArea: {
              z:-2,
              silent: true, // 防止区域触发事件
              itemStyle: {
                color: 'transparent' // 此处的颜色会被每个区间内定义的颜色覆盖
              },
              data: [
                // 第一个背景区间：0 到 60，颜色为浅红色
                [
                  {yAxis: 0,itemStyle: {color: 'rgba(57,73,171,0.8)'}},
                  {yAxis: 4}
                ],
                // 第二个背景区间：60 到 80，颜色为浅黄色
                [
                  {yAxis: 4,itemStyle: {color: 'rgba(92,107,192,0.8)'}},
                  {yAxis: 6}
                ],
                [
                  {yAxis: 6,itemStyle: {color: 'rgba(121,134,203,0.8)'}},
                  {yAxis: 8}
                ]
              ]
            },
            markLine: {
              silent: true,
              symbol: 'none',
              lineStyle: {
                // color: '#000',
                width: 2,
                type: 'solid'
              },
              data: [{ yAxis: 10 }],
              z: 0,  // 分割线层级调低（在柱状图下方）
              label: { show: false }
            },
            itemStyle:{
              color:'#156082'
            }
          }
        ]
      });
    },
    async download(){
      const loading = this.$loading({
        lock: true,
        text: '正在整理报告信息，即将开始下载。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)'
      })
      let cateDom = document.getElementById("charts2")
      let cateChart = echarts.getInstanceByDom(cateDom)
      let cateResultImg = cateChart.getDataURL({
        type: 'png',
        pixelRatio: 2
      })

      let typeDom = document.getElementById("charts3")
      let typeChart = echarts.getInstanceByDom(typeDom)
      let typeResultImg = typeChart.getDataURL({
        type: 'png',
        pixelRatio: 2
      })

      try {
        const response = await this.$upload('/pdf/pdf?id='+this.$route.query.eid, {
          cate: cateResultImg,
          type: typeResultImg
        });
        const blob = response.data;
        const buffer = await blob.arrayBuffer();
        const uint8Array = new Uint8Array(buffer.slice(0, 5)); // 读取前5字节
        const signature = String.fromCharCode(...uint8Array);
        const fileName = '汉语儿童理解与表达词汇测验 '+this.baseInfo.name+' '+this.baseInfo.age
        if (signature === '%PDF-') {
          // 是PDF文件
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName+'.pdf';
          link.click();
          URL.revokeObjectURL(url);
          loading.close()
        } else {
          // 尝试解析JSON错误
          loading.close()
          const text = await blob.text();
          try {
            const error = JSON.parse(text);
            this.$layer.msg(error.message);
          } catch {
            this.$layer.msg('未知错误格式');
          }
        }
      }catch (err) {
        // 显示错误信息（来自接口或默认提示）
        loading.close()
        this.$layer.msg('上传失败:'+ (err.message || '未知错误'));
      }
    },
    startEdit() {
      if (this.isPrint) return;
      this.editingRemark = this.remark;
      this.isEditing = true;
    },
    saveRemark() {
      this.$post("report/saveRemark", {
        exam_id: this.$route.query.eid,
        remark: this.editingRemark
      }).then(res => {
        if (res.code === 200) {
          this.remark = this.editingRemark;
          this.isEditing = false;
          this.$layer.msg("保存成功");
        } else {
          this.$layer.msg(res.msg);
        }
      }).catch(() => {
        this.$layer.msg("网络异常，请稍后重试！");
      });
    },
    cancelEdit() {
      this.isEditing = false;
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style>
.el-loading-spinner .el-loading-text , .el-icon-loading{
  color: #FFFFFF !important;
}
</style>
<style lang="less" scoped>
@import url("../../assets/css/page/revt_result");
/*模拟对角线*/
.out{
  border-top:40px transparent solid;/*上边框宽度等于表格第一行行高*/
  width:0px;/*让容器宽度为0*/
  height:0px;/*让容器高度为0*/
  border-left:130px transparent solid;/*左边框宽度等于表格第一行第一格宽度*/
  position:relative;/*让里面的两个子容器绝对定位*/
  font-size: 14px;
}

.table-cate {
  font-style: normal;
  display: block;
  position: absolute;
  top: -40px;
  left: -50px;
  width: 50px;
}

em {
  font-style: normal;
  display: block;
  position: absolute;
  top: -20px;
  right: 80px;
  width: 50px;
}
.score-td{
  text-align: center;
  position: relative;
}
.cate-full{
  position: absolute;
  right: 10px;
  //color: #b1b1b1;
}
.cate-symbol{
  position: absolute;
  right: 42px;
}
.score-td-title{
  width: 95px;
  text-align: center;
}
.input > span{
  padding: 0 10px;
}
.main-title{
  font-size: 25px;
  font-weight: bold;
  position: relative;
  padding-left: 24px;
  margin-left: 4px;
}
.sn{
  font-size: 25px;
  font-weight: bold;
}
.main-title::before{
  position: absolute;
  content: '';
  top: 50%;
  left: 5px;
  width: 18px;
  height: 18px;
  border: 2px solid #0c2047;
  transform: translate(-7px, -50%);
  border-radius: 50%;
  box-sizing: border-box;
}
.main-title::after{
  position: absolute;
  content: '';
  top: 50%;
  left: 10px;
  width: 10px;
  height: 10px;
  border: 2px solid #0c2047;
  transform: translate(-8px, -50%);
  border-radius: 50%;
  box-sizing: border-box;
}
.subheading{
  font-size: 18px;
  font-weight: bold;
  position: relative;
  padding-left: 20px;
  margin: 8px 0 8px 28px;
  color: #0c2047;
}
.subheading::before{
  position: absolute;
  content: '';
  width: 12px;
  height: 12px;
  background-color: #0c2047;
  left: 0;
  top: 50%;
  transform: rotate(45deg) translate(0, -50%);
}
.result-remark{
  text-indent: 32px;
  //background: #eee;
  font-size: 16px;
  //border: 1px solid #808080;
  padding: 8px 0;
  margin-bottom: -1px;
}
</style>
